"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = require("@antv/util");
var base_1 = require("./base");
var point_1 = require("./point");
var text_1 = require("./shape/text");
var parse_fields_1 = require("./util/parse-fields");
/**
 * Text 类型的几何图形
 */
var Text = /** @class */ (function (_super) {
    tslib_1.__extends(Text, _super);
    function Text(cfg) {
        var _this = _super.call(this, tslib_1.__assign({ type: 'text', shapeType: 'text' }, cfg)) || this;
        // 每一个 Element 对应一个确定的 shapeFactory
        _this.set('shapeFactory', text_1.default);
        return _this;
    }
    Text.prototype.content = function (field, callback) {
        if (_.isObject(field)) {
            this.set('contentOptions', field);
        }
        else {
            var fields = parse_fields_1.parseFields(field);
            this.set('contentOptions', {
                fields: fields,
                callback: callback,
            });
        }
        return this;
    };
    // 获取 content 配置
    Text.prototype._getContent = function (contentOptions, origin) {
        var fields = contentOptions.fields || [];
        var callback = contentOptions.callback;
        if (callback) { // content({ fields: [ 'a', 'b' ], callback(a, b) {} })
            var params = fields.map(function (field) {
                return origin[field];
            });
            return callback.apply(void 0, params);
        }
        return origin[fields[0]]; // content({ fields: [ 'a' ] })
    };
    /**
     * @override
     * @desc 添加content内容,复写cfg.text
     */
    Text.prototype.getDrawCfg = function (obj) {
        var cfg = _super.prototype.getDrawCfg.call(this, obj);
        var contentOptions = this.get('contentOptions');
        if (contentOptions) {
            cfg.text = this._getContent(contentOptions, obj[base_1.FIELD_ORIGIN]);
        }
        return cfg;
    };
    return Text;
}(point_1.default));
exports.default = Text;
//# sourceMappingURL=text.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/text.js
// module id = 822
// module chunks = 37